import { useEffect } from "react"

import { Checkbox } from "@/atoms"
import { YES } from "@/helpers/filters.helper"
import { useFilters, useStateFilter } from "@/hooks/useFilters"
import { useLogger } from "@/hooks/useLogger"

import type { CheckboxInlineFilterProps } from "."

export const CheckboxInlineFilter = (props: CheckboxInlineFilterProps) => {
  const { searchParams, setSearchParams } = useFilters()
  const { logger, EVENTS } = useLogger()
  const { placement, keyFilter, children } = props
  const createInitialFilterState = (obj = searchParams) => ({
    [keyFilter]: (obj.get(keyFilter) || "").toUpperCase()
  })

  const onChangeState = (
    prev: Record<string, any>,
    state: Record<string, any>
  ) => {
    const next = new URLSearchParams(prev)
    const value = state[keyFilter]

    if (value === YES) next.set(keyFilter, `${value}`)
    else next.delete(keyFilter)

    return next
  }
  const { filterState, reset, onFilterStateChange, onOk } = useStateFilter(
    createInitialFilterState(),
    {
      onChangeState,
      setSearchParams
    }
  )

  useEffect(() => {
    const checked = filterState.values[keyFilter]
    const checkedInUrl = searchParams.get(keyFilter)
    const result = checked !== checkedInUrl

    if (result) {
      reset(createInitialFilterState())
    }

    onOk()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams])

  return (
    <Checkbox
      checked={filterState.values?.[keyFilter] === YES}
      onChange={(e) => {
        const value = e.target.checked ? YES : undefined

        onFilterStateChange({
          [keyFilter]: value
        })

        logger.info(EVENTS.ANALYTIC_EVENTS.TAB.FILTER.QUICK_FILTERS, {
          name: keyFilter,
          key: keyFilter,
          placement,
          value
        })
      }}
    >
      {children}
    </Checkbox>
  )
}
